import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of, switchMap, map } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private currentLang = new BehaviorSubject<string>('en');
  private translations: any = {};

  constructor(private http: HttpClient, private translatePipe: TranslatePipe) {
    const saved = localStorage.getItem('selectedLang') || 'en';
    this.setLanguage(saved);
  }

  setLanguage(lang: string) {
    if (lang === this.currentLang.value) return;

    localStorage.setItem('selectedLang', lang);
    this.currentLang.next(lang);
  }

  get currentLang$() {
    return this.currentLang.asObservable();
  }

  translate(key: string): Observable<string> {
    return this.currentLang.pipe(
      switchMap((lang) => {
        if (this.translations[lang]) {
          return of(this.translations[lang][key] || key);
        }

        return this.http.get<{ [key: string]: string }>(`assets/i18n/${lang}.json`).pipe(
          map((res) => {
            this.translations[lang] = res;
            return res[key] || key;
          })
        );
      })
    );
  }

  translateMethod(label: any) {
    return this.translatePipe.transform(label);
  }
}
